import { InformationCircleIcon } from "@heroicons/react/24/outline";
import Joi from "joi-browser";

function DescriptionWithInfo() {
  return (
    <div className="flex flex-col gap-y-1 my-2 ml-2">
      <div className="flex gap-x-2 items-center text-blue-500">
        <InformationCircleIcon className="size-4" />
        <p className="text-sm">
          The Google Sheet must be public - "Anyone with the link"
        </p>
      </div>
    </div>
  );
}

export const sheetURLFieldTemplate = {
  name: "sheetURL",
  label: "Google Sheet Link *",
  descriptionWithInfo: <DescriptionWithInfo />,
  type: "text",
};

export const sheetURLFieldSchema = {
  sheetURL: Joi.string().uri().required().label("sheetURL"),
};
